import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";
import { FiChevronRight } from "react-icons/fi";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { BsFire } from "react-icons/bs";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <Header />
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  // Calculate pricing
  const originalPrice = parseFloat(product.price);
  const salePrice = (originalPrice * 0.3).toFixed(2); // Mocking 70% off

  return (
    <div className="product-detail">
      <Header />

      <div className="breadcrumb">
        <Link onClick={toTop} to="/">
          Home
        </Link>{" "}
        <FiChevronRight />
        <span className="current">Bottoms</span>
      </div>

      <div className="product-header">
        <h1 className="product-title">{product.name}</h1>
        <div className="product-rating">
          <div className="stars">
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStarHalfAlt />
          </div>
          <span className="rating-score">4.0</span>
          <span className="rating-count">({product.reviews || 56})</span>
        </div>
      </div>

      <div className="product-main-content">
        <div className="product-gallery">
          <div className="main-image-container">
            <img
              src={product.images?.[selectedImage] || product.image}
              alt={product.name}
              className="main-image"
            />
          </div>

          <div className="thumbnail-list">
            {(product.images || [product.image]).map((img, idx) => (
              <button
                key={idx}
                className={`thumbnail-btn ${
                  selectedImage === idx ? "active" : ""
                }`}
                onClick={() => setImage(idx)}
              >
                <img src={img} alt={`Thumbnail ${idx + 1}`} />
              </button>
            ))}
          </div>
        </div>

        <div className="product-details-sidebar">
          <div className="price-section">
            <div className="current-price-row">
              <span className="sale-price">${salePrice}</span>
              <span className="original-price strike-through">
                ${originalPrice.toFixed(2)}
              </span>
              <span className="discount-badge">Save 70%</span>
            </div>
          </div>

          <div className="size-section">
            <p className="selection-label">
              <strong>Color:</strong>
            </p>
            <div className="size-grid">
              {product.colors?.map((size, index) => {
                return (
                  <button
                    key={size}
                    className={`size-btn  ${
                      selectedColor === size ? "active" : ""
                    }`}
                    onClick={() => setSelectedColor(size)}
                  >
                    {size}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="size-section">
            <p className="selection-label">
              <strong>Size:</strong>
            </p>
            <div className="size-grid">
              {product.size?.map((size, index) => {
                return (
                  <button
                    key={size}
                    className={`size-btn  ${
                      selectedSize === size ? "active" : ""
                    }`}
                    onClick={() => setSelectedSize(size)}
                  >
                    {size}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="urgency-message">
            <BsFire className="fire-icon" />
            <p>
              <strong>Going fast!</strong> 90+ purchased in last 7 days
            </p>
          </div>

          <button className="btn-add-to-basket" onClick={handleAddToCart}>
            Add to Basket
          </button>
        </div>
      </div>

      <div className="product-highlight-banner">
        <p>
          Workwear-inspired high-rise barrel-leg pants made from lightweight
          cotton canvas.
        </p>
      </div>

      <div className="product-accordion">
        <div className="accordion-header">
          <h2>Product details</h2>
        </div>
        <div className="accordion-content">
          {product.description.map((des, index) => (
            <p key={index}>{des}</p>
          ))}

          <div className="detail-section">
            <h3>Product Highlights</h3>
            <ul>
              {product.Features.map((fea, index) => (
                <li key={index}>{fea}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProductDetail;
